export const parseTime = (input: string) => {
  const indexOfDot = input.indexOf('.')
  const correctInput = indexOfDot !== -1 ? input.slice(0, indexOfDot) : input
  const [h, m, s] = correctInput.split(':')
  return {hour: +h || 0, minutes: +m || 0, seconds: +s || 0}
}
